import React, {Component} from "react"
import styles from "./NavigationButton.module.css"
import {Model} from "Model"
import {FormID} from "interfaces"
import {observer} from "mobx-react"
import classNames from "classnames"
import {computed, observable} from "mobx"
import {
    isEnableSubmitButton,
    ENROLLMENT_APPLICATION,
    UPLOAD_DISABILITY_SUPPORTING_DOCUMENTS,
    hasAllDisabilityDocumentsRequired,
    APPLICATION_CAREER_INFORMATION
} from "helper/Methods"

interface Props {
    model: Model
    className?: string
    setTabForms?: Function
}

@observer
export class NavigationButton extends Component<Props, {}> {
    @computed
    private get nextButtonEnabled(): boolean {
        const model = this.props.model
        if (model.getNextFormId() === null && model.getFormId() === "submission") {
            return false
        }
        return true
    }

    @observable
    private submitButtonEnabled = true

    @computed
    private get saveButtonEnabled(): boolean {
        const model = this.props.model
        if (model.form.type === "pdf" && !model.iframeLoaded) {
            return false
        }
        return true
    }

    public render() {
        const {model, className} = this.props
        const {
            document: {json_data}
        } = model

        return (
            <div className={classNames(styles.root, className)}>
                <div className={styles.container}>
                    {/* Left group: BACK button */}
                    <div className={styles.leftGroup}>
                        <button
                            className={classNames(styles.button, styles.buttonBack)}
                            disabled={model.getPreviousFormId() === null}
                            onClick={() => {
                                const form_id: FormID = model.getPreviousFormId()
                                model.setFormId(form_id)
                            }}>
                            <svg
                                className={styles.circleArrowIcon}
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle
                                    cx="8"
                                    cy="8"
                                    r="7"
                                    stroke="currentColor"
                                    strokeWidth="1.2"
                                />
                                <path
                                    d="M8.5 5.5L6 8L8.5 10.5"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6 8H11"
                                    stroke="currentColor"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                />
                            </svg>
                            <span>BACK</span>
                        </button>
                    </div>

                    {/* Center group: SAVE, My Signature, My Initials */}
                    <div className={styles.centerGroup}>
                        {this.nextButtonEnabled && (
                            <>
                                {model.getFormId() === APPLICATION_CAREER_INFORMATION ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonSave)}
                                        disabled={model.isSaving}
                                        onClick={async () => {
                                            const success = await model.saveCareerInformation()
                                            if (success) {
                                                this.props.setTabForms()
                                            }
                                        }}>
                                        <svg
                                            className={styles.diskIcon}
                                            viewBox="0 0 24 24"
                                            fill="currentColor">
                                            <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                                        </svg>
                                        <span>SAVE</span>
                                    </button>
                                ) : model.getFormId() === ENROLLMENT_APPLICATION ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonSave)}
                                        disabled={model.isSaving}
                                        onClick={async () => {
                                            const success = await model.saveEnrollmentApplication()
                                            if (success) {
                                                this.props.setTabForms()
                                            }
                                        }}>
                                        <svg
                                            className={styles.diskIcon}
                                            viewBox="0 0 24 24"
                                            fill="currentColor">
                                            <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                                        </svg>
                                        <span>SAVE</span>
                                    </button>
                                ) : model.getFormId() === UPLOAD_DISABILITY_SUPPORTING_DOCUMENTS ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonSave)}
                                        onClick={async () => {
                                            if (
                                                !hasAllDisabilityDocumentsRequired(
                                                    json_data.forms
                                                ) &&
                                                json_data.disabilitySelected
                                            ) {
                                                alert(`You need to fill the previous forms first.`)
                                            } else {
                                                const success = await model.saveAndContinueWithReadyToEnroll()
                                                model.dispatcher2.dispatch()
                                            }
                                            this.props.setTabForms()
                                        }}>
                                        <svg
                                            className={styles.diskIcon}
                                            viewBox="0 0 24 24"
                                            fill="currentColor">
                                            <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                                        </svg>
                                        <span>SAVE</span>
                                    </button>
                                ) : (
                                    <button
                                        className={classNames(styles.button, styles.buttonSave)}
                                        disabled={model.isSaving}
                                        onClick={async () => {
                                            const success = await model.save()
                                            if (success) {
                                                this.props.setTabForms()
                                            }
                                        }}>
                                        <svg
                                            className={styles.diskIcon}
                                            viewBox="0 0 24 24"
                                            fill="currentColor">
                                            <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                                        </svg>
                                        <span>SAVE</span>
                                    </button>
                                )}

                                <button
                                    className={classNames(styles.button, styles.buttonAux)}
                                    onClick={() => {
                                        model.signaturePopup = {
                                            show: true,
                                            signature_key: "",
                                            mode: "signature"
                                        }
                                    }}>
                                    <svg
                                        className={styles.quillIcon}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round">
                                        <path d="M12 19l7-7 3 3-7 7-3-3z" />
                                        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
                                        <path d="M2 2l7.586 7.586" />
                                        <circle cx="11" cy="11" r="2" />
                                    </svg>
                                    <span>My Signature</span>
                                    {json_data?.signature && (
                                        <span className={styles.badgeSet}>Set</span>
                                    )}
                                </button>

                                <button
                                    className={classNames(styles.button, styles.buttonAux)}
                                    onClick={() => {
                                        model.signaturePopup = {
                                            show: true,
                                            signature_key: "",
                                            mode: "initials"
                                        }
                                    }}>
                                    <svg
                                        className={styles.initialsIcon}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round">
                                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                                    </svg>
                                    <span>My Initials</span>
                                    {json_data?.initials && (
                                        <span className={styles.badgeSet}>Set</span>
                                    )}
                                </button>
                            </>
                        )}
                    </div>

                    {/* Right group: SAVE & CONTINUE or SUBMIT */}
                    <div className={styles.rightGroup}>
                        {this.nextButtonEnabled && (
                            <>
                                {model.getFormId() === APPLICATION_CAREER_INFORMATION ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonNext)}
                                        disabled={model.isSaving || !this.saveButtonEnabled}
                                        onClick={async () => {
                                            if (model.isSaving) return
                                            const success = await model.saveCareerInformation()
                                            if (success) {
                                                const form_id: FormID = model.getNextFormId()
                                                model.setFormId(form_id)
                                            }
                                        }}>
                                        <span>SAVE & CONTINUE</span>
                                        <svg
                                            className={styles.circleArrowIconNext}
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="1.2"
                                            />
                                            <path
                                                d="M7.5 5.5L10 8L7.5 10.5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 8H5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                ) : model.getFormId() === ENROLLMENT_APPLICATION ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonNext)}
                                        disabled={model.isSaving || !this.saveButtonEnabled}
                                        onClick={async () => {
                                            if (model.isSaving) return
                                            const success = await model.saveEnrollmentApplication()
                                            if (success) {
                                                const form_id: FormID = model.getNextFormId()
                                                if (form_id) {
                                                    model.setFormId(form_id)
                                                }
                                            }
                                        }}>
                                        <span>
                                            SAVE &{" "}
                                            {!json_data.isApplicationSubmitted
                                                ? `SUBMIT`
                                                : `CONTINUE`}
                                        </span>
                                        <svg
                                            className={styles.circleArrowIconNext}
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="1.2"
                                            />
                                            <path
                                                d="M7.5 5.5L10 8L7.5 10.5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 8H5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                ) : model.getFormId() === UPLOAD_DISABILITY_SUPPORTING_DOCUMENTS ? (
                                    <button
                                        className={classNames(styles.button, styles.buttonNext)}
                                        disabled={model.isSaving || !this.saveButtonEnabled}
                                        onClick={async () => {
                                            if (model.isSaving) return
                                            if (
                                                !hasAllDisabilityDocumentsRequired(
                                                    json_data.forms
                                                ) &&
                                                json_data.disabilitySelected
                                            ) {
                                                alert(`You need to fill the previous forms first.`)
                                            } else {
                                                const success = await model.saveAndContinueWithReadyToEnroll()
                                                model.dispatcher2.dispatch()
                                                const form_id: FormID = model.getNextFormId()
                                                if (form_id) {
                                                    model.setFormId(form_id)
                                                }
                                            }
                                        }}>
                                        <span>
                                            SAVE &{" "}
                                            {json_data.disabilitySelected &&
                                            !json_data.disabilitySubmitted
                                                ? `SUBMIT`
                                                : `CONTINUE`}
                                        </span>
                                        <svg
                                            className={styles.circleArrowIconNext}
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="1.2"
                                            />
                                            <path
                                                d="M7.5 5.5L10 8L7.5 10.5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 8H5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                ) : (
                                    <button
                                        className={classNames(styles.button, styles.buttonNext)}
                                        disabled={model.isSaving || !this.saveButtonEnabled}
                                        onClick={async () => {
                                            if (model.isSaving) return
                                            const success = await model.save()
                                            model.dispatcher2.dispatch()
                                            if (success) {
                                                const form_id: FormID = model.getNextFormId()
                                                if (form_id) {
                                                    model.setFormId(form_id)
                                                }
                                            }
                                        }}>
                                        <span>SAVE & CONTINUE</span>
                                        <svg
                                            className={styles.circleArrowIconNext}
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="1.2"
                                            />
                                            <path
                                                d="M7.5 5.5L10 8L7.5 10.5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 8H5"
                                                stroke="currentColor"
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                )}
                            </>
                        )}

                        {!this.nextButtonEnabled && (
                            <button
                                className={classNames(styles.button, styles.buttonNext)}
                                disabled={
                                    json_data && json_data.isSubmitted
                                        ? true
                                        : isEnableSubmitButton(
                                              json_data.forms || [],
                                              json_data.campus || "",
                                              this.props.model.campusesInfo || [],
                                              json_data.program || ""
                                          )
                                }
                                onClick={async () => {
                                    this.submitButtonEnabled = false
                                    await model.submit()
                                    this.forceUpdate()
                                }}>
                                <span>SUBMIT</span>
                                <svg
                                    className={styles.circleArrowIconNext}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle
                                        cx="8"
                                        cy="8"
                                        r="7"
                                        stroke="currentColor"
                                        strokeWidth="1.2"
                                    />
                                    <path
                                        d="M7.5 5.5L10 8L7.5 10.5"
                                        stroke="currentColor"
                                        strokeWidth="1.3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10 8H5"
                                        stroke="currentColor"
                                        strokeWidth="1.3"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
